import React from 'react';

interface Props {
  isPro: boolean;
  nextBillingDate?: string | null;
  loading?: boolean;
  cancelAtPeriodEnd?: boolean;
  onCheckout: () => void;
  onManageSubscription?: () => void;
}

const BillingCheckoutPanel: React.FC<Props> = ({
  isPro,
  nextBillingDate,
  loading,
  cancelAtPeriodEnd,
  onCheckout,
  onManageSubscription,
}) => {
  return (
    <div className="ta-panel" style={{ padding: 16 }}>
      <div className="ta-h2" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        💳 자동결제 / 구독
        <div style={{ marginLeft: 'auto', fontSize: 12, color: 'var(--sub)' }}>
          {loading
            ? '상태 확인 중…'
            : isPro
              ? cancelAtPeriodEnd
                ? '해지 예약됨'
                : 'Pro 활성'
              : '무료'}
        </div>
      </div>

      <div className="ta-body" style={{ marginTop: 8, color: 'var(--sub)', lineHeight: 1.6 }}>
        {isPro ? (
          <>
            현재 <b style={{ color: 'var(--text)' }}>Pro 자동결제 구독</b> 상태입니다.
            <br />
            {nextBillingDate ? (
              <>
                다음 결제 예정일: <b style={{ color: 'var(--text)' }}>{nextBillingDate}</b>
              </>
            ) : (
              '다음 결제 예정일 정보가 없습니다.'
            )}
            <br />
            {cancelAtPeriodEnd
              ? '해지 예약 상태입니다. 현재 결제기간 종료일까지 이용 가능하며 다음 자동결제는 진행되지 않습니다.'
              : '해지 예약 전까지 등록된 카드로 결제 주기마다 자동 승인됩니다.'}
          </>
        ) : (
          <>
            현재는 <b style={{ color: 'var(--text)' }}>무료</b> 상태입니다.
            <br />
            Pro 플랜을 이용하려면 자동결제 카드를 먼저 등록해야 합니다.
            <br />
            테스트 프로필에서는 1일 간격으로 다음 결제 대상이 생성됩니다.
          </>
        )}
      </div>

      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 14 }}>
        {!isPro ? (
          <button
            className="ta-btn ta-btn--primary"
            onClick={onCheckout}
            style={{ minWidth: 160 }}
          >
            자동결제 카드 등록
          </button>
        ) : null}

        {isPro ? (
          <button
            className="ta-btn ta-btn--solid"
            onClick={onManageSubscription}
            disabled={!onManageSubscription || Boolean(cancelAtPeriodEnd)}
            style={{ minWidth: 140 }}
            title={
              cancelAtPeriodEnd
                ? '이미 해지 예약된 상태입니다.'
                : !onManageSubscription
                  ? '구독 관리 기능이 아직 연결되지 않았습니다.'
                  : undefined
            }
          >
            {cancelAtPeriodEnd ? '해지 예약됨' : '구독 해지 예약'}
          </button>
        ) : null}

        <div style={{ fontSize: 12, color: 'var(--sub)', alignSelf: 'center' }}>
          카드 등록 완료 후 서버가 빌링키를 저장하고 다음 결제일을 관리합니다.
        </div>
      </div>
    </div>
  );
};

export default BillingCheckoutPanel;
